module.exports = __webpack_public_path__ + "static/media/1_A1_04.04c1948a.png";